import { INTERNAL_TypographyBase } from '@10d/tend-ui-typography/Base';
import styled from 'styled-components';

const Root = styled(INTERNAL_TypographyBase) `
  color: inherit;
  font-size: inherit;
  line-height: inherit;
`;

export { Root };
//# sourceMappingURL=styled.js.map
